import { render } from "./DeadHorsesPage.vue?vue&type=template&id=662187ae&scoped=true"
import script from "./DeadHorsesPage.vue?vue&type=script&lang=js"
export * from "./DeadHorsesPage.vue?vue&type=script&lang=js"

import "./DeadHorsesPage.vue?vue&type=style&index=0&id=662187ae&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-662187ae"]])

export default __exports__